export const getImage = (imageName) => {
  const bucketUrl = 'https://internet-banking-assets.s3.amazonaws.com';
  const companyKey = process.env.REACT_APP_COMPANY_KEY;
  const dir = 'web';

  return `${bucketUrl}/${companyKey}/${dir}/${imageName}`;
}